/* 4 Gauge — Shop page v2 runtime (2026-11-03). sections/cro-shop-v2.liquid.
   Add-to-cart for single-variant products (PowerPhase, Testosterone Support), qty 1 or 4, then opens the
   theme's slide-out cart through the same eventBus contract the v5 PDP uses. Falls back to /cart.
   Buy 3, Get 1 Free is an automatic discount per product; the cart drawer shows it once qty >= 4. */
(function () {
  'use strict';
  var root = document.querySelector('.cgs');
  if (!root) return;
  var CART = root.getAttribute('data-cart') || '/cart';
  var toast = root.querySelector('.cgs-toast');
  var busy = false;

  function track(name, data) {
    var e = { event: name, ts: Date.now() };
    if (data) { for (var k in data) { if (Object.prototype.hasOwnProperty.call(data, k)) e[k] = data[k]; } }
    (window.__pdpEvents = window.__pdpEvents || []).push(e);
  }
  function getCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function say(msg) {
    if (!toast) return;
    toast.textContent = msg; toast.hidden = false;
    clearTimeout(say.t); say.t = setTimeout(function () { toast.hidden = true; }, 3200);
  }
  function openDrawer() {
    if (window.eventBus) {
      window.eventBus.emit('render:cart:drawer');
      window.eventBus.emit('open:cart:drawer', { scrollToTop: true });
      if (window.wetheme && window.wetheme.updateCartCount) { getCart().then(function (c) { window.wetheme.updateCartCount(c); }); }
      return true;
    }
    return false;
  }
  function qtyOf(cart, variantId) {
    var n = 0;
    (cart.items || []).forEach(function (it) { if (String(it.variant_id) === String(variantId)) n += it.quantity; });
    return n;
  }

  function add(btn) {
    if (busy) return;
    var id = parseInt(btn.getAttribute('data-add'), 10);
    var qty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
    if (!id) return;
    busy = true;
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    track('add_to_cart', { source: 'shop_page', variant: id, qty: qty, product: btn.getAttribute('data-name') });

    getCart().catch(function () { return { items: [] }; }).then(function (before) {
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
      }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
        .then(function () { return getCart(); })
        .then(function (after) {
          // Safety net: if the line didn't grow by the requested amount, force it.
          var expected = qtyOf(before, id) + qty;
          if (qtyOf(after, id) >= expected) return after;
          var updates = {}; updates[id] = expected;
          return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: updates }) })
            .then(function (r) { return r.json(); });
        });
    }).then(function () {
      busy = false;
      btn.disabled = false; btn.textContent = 'Added ✓'; btn.classList.add('cgs-added');
      setTimeout(function () { btn.textContent = label; btn.classList.remove('cgs-added'); }, 2200);
      if (!openDrawer()) { say('Added to your cart'); setTimeout(function () { window.location.href = CART; }, 600); }
    }).catch(function (err) {
      busy = false;
      btn.disabled = false; btn.textContent = label;
      console.error('4 Gauge shop add-to-cart failed:', err);
      window.location.href = CART;
    });
  }

  root.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-add]');
    if (btn && root.contains(btn)) { ev.preventDefault(); add(btn); }
  });
})();
